import type { MergeHistoryUser } from "types/MergeHistory";

export function formatUser(user: MergeHistoryUser | null | undefined) {
  if (!user) return "—";
  return user.name || user.email || user.id || "—";
}

export function formatMergeHistoryTimestamp(ts: number | null | undefined) {
  if (ts == null || !Number.isFinite(Number(ts)) || Number(ts) <= 0) return "—";
  return new Date(Number(ts)).toLocaleString();
}
